module.exports = "/_next/static/images/PersonalizationAroundTheGlobe-b052fd4085d1a5dad5e03333db19e16b.webp";